<template>
    <div>
        <main-banner v-bind:image="'src/assets/images/' + image"></main-banner>
        <h2 class="blue--text mt-5">{{$t('pages.contact.title')}}</h2>
        <div class="mt-2 section-content" v-html="$t('pages.contact.about')"></div>
        <h2 class="blue--text mt-5">{{$t('pages.contact.location.title')}}</h2>
        <v-layout class="row wrap mt-2">
            <v-flex xs12 md6 lg8>
                <gmap-map :center="center" :options="{scrollwheel: false}" :zoom="14" style="height: 300px !important">
                    <gmap-marker v-for="m in markers" :key="m" :position="m.position" :clickable="false" :draggable="false" @click="center=m.position"></gmap-marker>
                </gmap-map>
            </v-flex>
            <v-flex xs12 md6 lg4>
                <h2><strong>{{contact.company}}</strong></h2>
                <h3>{{$t('pages.contact.location.street')}}</h3>
                <h3>{{$t('pages.contact.location.city')}}</h3>
                <h3>{{$t('pages.contact.location.country')}}</h3>
                <h3>{{contact.phone}}</h3>
                <h3><a v-bind:href="'mailto:' + contact.email">{{contact.email}}</a></h3>
                <h3><a v-bind:href="contact.www" target="_blank">{{contact.www}}</a></h3>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
    import * as VueGoogleMaps from 'vue2-google-maps';
    import Vue from 'vue';
    import MainBanner from '../sections/MainBanner.vue'

    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyDV1VT6t2GE2yjSb5EiCvxBPBP76NHwLmA'
        }
    });

    export default {
        components: {
            'main-banner': MainBanner
        },
        data() {
            return {
                contact: {
                    company: "IQVIA",
                    phone: "+48 22 389 1000",
                    email: "serwis_pl@quintilesims.com",
                    www: "http://iqvia.com"
                },
                image: 'contact.jpg',
                message: {
                    name: '',
                    email: '',
                    content: ''
                },
                center: { lat: 52.1835271, lng: 20.9950121 },
                  
                markers: [
                    {
                        position: { lat: 52.1835271, lng: 20.9950121 }
                    }
                ]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Contact.vue?fe3b7346